import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { GhostButton } from "src/components/Buttons";
import { BLUE_LIGHT, OLD_BLUE, PRIMARY_BLACK } from "src/constants/colors";

export const DayContainer = styled.button<{
  isSelected: boolean;
  isDisabled: boolean;
}>`
  background-color: ${({ isSelected, isDisabled }) => {
    if (isSelected)
      return css`
        ${OLD_BLUE}
      `;
    else if (isDisabled) return css`rgba(255,255,255)`;
    else return css`rgba(239, 242, 246, 1)`;
  }}
  border: 0;
  border-radius: 8px;
  color: ${({ isSelected }) => (isSelected ? "rgb(255,255,255)" : PRIMARY_BLACK)};
  height: 34px;
  min-height: 34px;
  width: 40px;
  min-width: 40px;
  position: relative;
  margin: 2px;

  &:hover {
    color: ${({ isSelected }) => (isSelected ? "rgb(255,255,255)" : OLD_BLUE)};
    background-color: ${({ isSelected, isDisabled }) => {
      if (isSelected)
        return css`
          ${OLD_BLUE}
        `;
      else if (isDisabled) return css`rgba(255,255,255)`;
      else
        return css`
          ${BLUE_LIGHT}
        `;
    }}
  }
`;

export const DayLabel = styled.div`
  font-size: 13px;
  font-weight: 500;
`;

export const CurrentDayIndicator = styled.div<{ isSelected: boolean }>`
  background-color: ${({ isSelected }) =>
    isSelected ? "rgb(255,255,255)" : "rgba(64, 117, 255, 1)"};
  border-radius: 50%;
  height: 3px;
  position: absolute;
  bottom: 5px;
  left: 50%;
  margin-left: -1.5px;
  width: 3px;
`;

export const HeaderTitle = styled.div`
  color: ${PRIMARY_BLACK};
  font-size: 14px;
  font-weight: 500;
`;

export const CalendarNavButton = styled(GhostButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  height: 24px;
  min-height: 24px;
  width: 24px;
  min-width: 24px;
  padding: 0;
  &:hover {
    background-color: BLUE_LIGHT;
    color: ${OLD_BLUE};
  }
`;
